import * as React from "react";
import { useState, useEffect} from "react";
import Modal from "../core/Modal";
import { toast } from "../../utils";
import * as moment from "moment";
import Select from 'react-select-new';
import jfetch from "../../utils/jfetch";

interface IProps {
  userContext?:any;
  hasMarketing?:any;
  v2Token?:any;
  lsSettings?:any;
}

function LeadSafariProgress(props:IProps){

    function handle_select(e){
      set_activity_id(e.value);
      return e.value;
    }

    async function get_activity_types_html(v2_token, rec_id){
        let json = await get_activity_types(v2_token, rec_id);
        let options = [];

        Object.entries(json).map(([key, value] : any) => {
          options.push({value : value.id, label: value.name});
        })
  
        set_activity_types(options);
    }

    async function get_activity_statuses(v2_token, rec_id) {
      let resp = await fetch(`https://api.chartec.net/v2/connectwise/sales/activities/statuses/${rec_id}`, {
        method: 'GET', 
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': v2_token
        }
      })
      let json = await resp.json();
      let options = [];

      Object.entries(json).map(([key, value] : any) => {
        options.push({value : value.id, label: value.name});
      })

      set_activity_statuses(options);
    }


    async function get_work_types(v2_token, rec_id) {
      let resp = await fetch(`https://api.chartec.net/v2/connectwise/time/work_types/${rec_id}`, {
        method: 'GET', 
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': v2_token
        }
      })
      let json = await resp.json();
      let options = [];

      Object.entries(json).map(([key, value] : any) => {
        options.push({value : value.id, label: value.name});
      })

      set_work_types(options);
    }
    
    async function get_activity_types(v2_token, rec_id) {
        let resp = await fetch(`https://api.chartec.net/v2/connectwise/sales/activities/types/${rec_id}`, {
          method: 'GET', 
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': v2_token
          }
        })
        let json = await resp.json();
        return json;
    }

    async function build_rows(json){
        let t_html = [];
        let to_html = [];
        let pd_html = [];
        let cc_html = [];
        let nd_html = [];
        let index_id = 0;
        Object.keys(json).forEach(function(k){
          if(k.match(/^[0-9]+$/) != null){
            var current_id = index_id;
            let contact_email = json[k].contact?.email || 'unknown';
            let contact_id = k;
            let company_name = json[k].contact?.company.name || 'unknown';
            let contact_phone = json[k].contact?.defaultPhoneNbr || 'unknown';
            let activites = {"today":[], "tomorrow":[], "pastdue":[], "completed":[], "noduedate":[], "future":[]};
            let statuses = {"closed" : [], "open" : []};
            
            for (let key in ls_settings.closedStatus) {
                statuses.closed.push(ls_settings.closedStatus[key].value);
            }
            
            for (let key in ls_settings.openStatus) {
                statuses.open.push(ls_settings.openStatus[key].value);
            }
        
            Object.keys(json[k].today).forEach(function(r){
              if(r.match(/^[0-9]+$/) != null){
                let short = json[k].today[r];
                activites.today = activites.today || [];
                activites.today.push(short);
                if(statuses.closed.includes(short['status'].id)){
                  activites.today['closed'] = activites.today['closed']++ || 1;
                } else if(statuses.open.includes(short['status'].id)){
                  activites.today['open'] = activites.today['open']++ || 1;
                } else {
                  activites.today['other'] = activites.today['other']++ || 1;
                }
              }
            });
    
            Object.keys(json[k].tomorrow).forEach(function(r){
              if(r.match(/^[0-9]+$/) != null){
                let short = json[k].tomorrow[r];
                activites.tomorrow = activites.tomorrow || [];
                activites.tomorrow.push(short);
                if(statuses.closed.includes(short['status'].id)){
                  activites.tomorrow['closed'] = activites.tomorrow['closed']++ || 1;
                } else if(statuses.open.includes(short['status'].id)){
                  activites.tomorrow['open'] = activites.tomorrow['open']++ || 1;
                } else {
                  activites.tomorrow['other'] = activites.tomorrow['other']++ || 1;
                }
              }
            });
    
            Object.keys(json[k].pastdue).forEach(function(r){
              if(r.match(/^[0-9]+$/) != null){
                let short = json[k].pastdue[r];
                activites.pastdue = activites.pastdue || [];
                activites.pastdue.push(short);
                if(statuses.closed.includes(short['status'].id)){
                  activites.pastdue['closed'] = activites.pastdue['closed']++ || 1;
                } else if(statuses.open.includes(short['status'].id)){
                  activites.pastdue['open'] = activites.pastdue['open']++ || 1;
                } else {
                  activites.pastdue['other'] = activites.pastdue['other']++ || 1;
                }
              }
            });
    
            Object.keys(json[k].completed).forEach(function(r){
              if(r.match(/^[0-9]+$/) != null){
                let short = json[k].completed[r];
                activites.completed = activites.completed || [];
                activites.completed.push(short);
                if(statuses.closed.includes(short['status'].id)){
                  activites.completed['closed'] = activites.completed['closed']++ || 1;
                } else if(statuses.open.includes(short['status'].id)){
                  activites.completed['open'] = activites.completed['open']++ || 1;
                } else {
                  activites.completed['other'] = activites.completed['other']++ || 1;
                }
              }
            });

            Object.keys(json[k].noduedate).forEach(function(r){
              if(r.match(/^[0-9]+$/) != null){
                let short = json[k].noduedate[r];
                activites.noduedate = activites.noduedate || [];
                activites.noduedate.push(short);
                if(statuses.closed.includes(short['status'].id)){
                  activites.noduedate['closed'] = activites.noduedate['closed']++ || 1;
                } else if(statuses.open.includes(short['status'].id)){
                  activites.noduedate['open'] = activites.noduedate['open']++ || 1;
                } else {
                  activites.noduedate['other'] = activites.noduedate['other']++ || 1;
                }
              }
            });

            Object.keys(json[k].noduedate).forEach(function(r){
              if(r.match(/^[0-9]+$/) != null){
                let short = json[k].noduedate[r];
                activites.noduedate = activites.noduedate || [];
                activites.noduedate.push(short);
                if(statuses.closed.includes(short['status'].id)){
                  activites.noduedate['closed'] = activites.noduedate['closed']++ || 1;
                } else if(statuses.open.includes(short['status'].id)){
                  activites.noduedate['open'] = activites.noduedate['open']++ || 1;
                } else {
                  activites.noduedate['other'] = activites.noduedate['other']++ || 1;
                }
              }
            });

            let today_html = [];
            if(Object.keys(activites.today).length){
              Object.keys(activites.today).forEach(function(a){
                if(a.match(/^[0-9]+$/) != null){
                  today_html.push(
                    <tr>
                      <td>{activites.today[a].id}</td>
                      <td>{activites.today[a].type.name}</td>
                      <td>{activites.today[a].name}</td>
                      <td>{activites.today[a].email}</td>
                      <td>{moment.utc(activites.today[a].schedule.dateEnd).format("MMMM Do, YYYY")}</td>
                      <td>{activites.today[a].status.name}</td>
                      <td>{!statuses.closed.includes(activites.today[a].status.id) ? <><button onClick={() => {current_time(), set_add_time_modal({open:true, email:contact_email, contact_id:contact_id, index_id:current_id, contact:json[k].contact, activity: activites.today[a]})}} className="btn btn-info btn-xs">Time Entry</button> | </> : ""}<button onClick={() => {set_due_date_modal({open: true, activity: activites.today[a]})}} className="btn btn-warning btn-xs">Due Date</button> | <button onClick={() => {set_add_activity({open:true, type:'', email:contact_email, contact_id:contact_id, index_id:current_id, contact:json[k].contact}), get_ac_activites_and_scores(v2_token, rec_id, contact_id), set_history(true)}} className="btn-xs btn btn-secondary"><i className="fa fa-history"></i></button></td>
                    </tr>
                  );
                }
              })
            }

            let tomorrow_html = [];
            if(Object.keys(activites.tomorrow).length){
              Object.keys(activites.tomorrow).forEach(function(a){
                if(a.match(/^[0-9]+$/) != null){
                  tomorrow_html.push(
                  <tr>
                      <td>{activites.tomorrow[a].id}</td>
                      <td>{activites.tomorrow[a].type.name}</td>
                      <td>{activites.tomorrow[a].name}</td>
                      <td>{activites.tomorrow[a].email}</td>
                      <td>{moment.utc(activites.tomorrow[a].schedule.dateEnd).format("MMMM Do, YYYY")}</td>
                      <td>{activites.tomorrow[a].status.name}</td>
                    <td>{!statuses.closed.includes(activites.tomorrow[a].status.id) ? <><button onClick={() => {current_time(), set_add_time_modal({open:true, email:contact_email, contact_id:contact_id, index_id:current_id, contact:json[k].contact, activity: activites.tomorrow[a]})}} className="btn btn-info btn-xs">Time Entry</button> | </> : ""}<button onClick={() => {set_due_date_modal({open: true, activity: activites.tomorrow[a]})}} className="btn btn-warning btn-xs">Due Date</button> |<button onClick={() => {set_add_activity({open:true, type:'', email:contact_email, contact_id:contact_id, index_id:current_id, contact:json[k].contact}), get_ac_activites_and_scores(v2_token, rec_id, contact_id), set_history(true)}} className="btn-xs btn btn-secondary"><i className="fa fa-history"></i></button></td>
                  </tr>);
                }
              })
            }

            let pastdue_html = [];
            if(Object.keys(activites.pastdue).length){
              Object.keys(activites.pastdue).forEach(function(a){
                if(a.match(/^[0-9]+$/) != null){
                  pastdue_html.push(
                  <tr>
                      <td>{activites.pastdue[a].id}</td>
                      <td>{activites.pastdue[a].type.name}</td>
                      <td>{activites.pastdue[a].name}</td>
                      <td>{activites.pastdue[a].email}</td>
                      <td>{moment.utc(activites.pastdue[a].schedule.dateEnd).format("MMMM Do, YYYY")}</td>
                      <td>{activites.pastdue[a].status.name}</td>
                    <td>{!statuses.closed.includes(activites.pastdue[a].status.id) ? <><button onClick={() => {current_time(), set_add_time_modal({open:true, email:contact_email, contact_id:contact_id, index_id:current_id, contact:json[k].contact, activity: activites.pastdue[a]})}} className="btn btn-info btn-xs">Time Entry</button> | </> : ""}<button onClick={() => {set_due_date_modal({open: true, activity: activites.pastdue[a]})}} className="btn btn-warning btn-xs">Due Date</button> | <button onClick={() => {set_add_activity({open:true, type:'', email:contact_email, contact_id:contact_id, index_id:current_id, contact:json[k].contact}), get_ac_activites_and_scores(v2_token, rec_id, contact_id), set_history(true)}} className="btn-xs btn btn-secondary"><i className="fa fa-history"></i></button></td>
                  </tr>);
                }
              })
            }
    
            let completed_html = [];
            if(Object.keys(activites.completed).length){
              Object.keys(activites.completed).forEach(function(a){
                if(a.match(/^[0-9]+$/) != null){
                  completed_html.push(
                  <tr>
                      <td>{activites.completed[a].id}</td>
                      <td>{activites.completed[a].type.name}</td>
                      <td>{activites.completed[a].name}</td>
                      <td>{activites.completed[a].email}</td>
                      <td>{moment.utc(activites.completed[a].schedule.dateEnd).format("MMMM Do, YYYY")}</td>
                      <td>{activites.completed[a].status.name}</td>
                    <td>{!statuses.closed.includes(activites.completed[a].status.id) ? <><button onClick={() => {current_time(), set_add_time_modal({open:true, email:contact_email, contact_id:contact_id, index_id:current_id, contact:json[k].contact, activity: activites.completed[a]})}} className="btn btn-info btn-xs">Time Entry</button> | </> : ""}<button onClick={() => {set_add_activity({open:true, type:'', email:contact_email, contact_id:contact_id, index_id:current_id, contact:json[k].contact}), get_ac_activites_and_scores(v2_token, rec_id, contact_id), set_history(true)}} className="btn-xs btn btn-secondary"><i className="fa fa-history"></i></button></td>
                  </tr>);
                }
              })
            }

            let no_due_html = [];
            if(Object.keys(activites.noduedate).length){
              Object.keys(activites.noduedate).forEach(function(a){
                if(a.match(/^[0-9]+$/) != null){
                  no_due_html.push(
                  <tr>
                      <td>{activites.noduedate[a].id}</td>
                      <td>{activites.noduedate[a].type.name}</td>
                      <td>{activites.noduedate[a].name}</td>
                      <td>{activites.noduedate[a].email}</td>
                      <td>{activites.noduedate[a].status.name}</td>
                    <td>{!statuses.closed.includes(activites.noduedate[a].status.id) ? <><button onClick={() => {current_time(), set_add_time_modal({open:true, email:contact_email, contact_id:contact_id, index_id:current_id, contact:json[k].contact, activity: activites.noduedate[a]})}} className="btn btn-info btn-xs">Time Entry</button> | <button onClick={() => {set_due_date_modal({open: true, activity: activites.noduedate[a]})}} className="btn btn-warning btn-xs">Due Date</button> | </> : ""} <button onClick={() => {set_add_activity({open:true, type:'', email:contact_email, contact_id:contact_id, index_id:current_id, contact:json[k].contact}), get_ac_activites_and_scores(v2_token, rec_id, contact_id), set_history(true)}} className="btn-xs btn btn-secondary"><i className="fa fa-history"></i></button></td>
                  </tr>);
                }
              })
            }

            if(today_html.length){
              t_html.push(
                  <div data-id={index_id} data-email={contact_email} className="panel panel-default">
                    <div className="panel-body">
                      <h5>{json[k].contact?.firstName || json[k].contact?.name} {json[k].contact?.lastName || ''} | {company_name} | <button className="btn btn-primary btn-xs" onClick={() => {set_add_activity({open:true, type:'', email:contact_email, contact_id:contact_id, index_id:current_id, contact:json[k].contact}), get_ac_activites_and_scores(v2_token, rec_id, contact_id), set_history(false)}}>Create Activity</button></h5>
                      <table className="table table-bordered table-condensed">
                        <thead>
                          <tr>
                            <th>ID</th>
                            <th>Type</th>
                            <th>Summary</th>
                            <th>Email</th>
                            <th>Due Date</th>
                            <th>Status</th>
                            <th>Options</th>
                          </tr>
                        </thead>
                        <tbody>
                          {today_html}
                        </tbody>
                      </table>
                    </div>
                  </div>
              );
            }

            if(tomorrow_html.length){
              to_html.push(
                  <div data-id={index_id} data-email={contact_email} className="panel panel-default">
                    <div className="panel-body">
                      <h5>{json[k].contact?.firstName || json[k].contact?.name} {json[k].contact?.lastName || ''} | {company_name} | <button className="btn btn-primary btn-xs" onClick={() => {set_add_activity({open:true, type:'', email:contact_email, contact_id:contact_id, index_id:current_id, contact:json[k].contact}), get_ac_activites_and_scores(v2_token, rec_id, contact_id), set_history(false)}}>Create Activity</button></h5>
                      <table className="table table-bordered table-condensed">
                        <thead>
                          <tr>
                            <th>ID</th>
                            <th>Type</th>
                            <th>Summary</th>
                            <th>Email</th>
                            <th>Due Date</th>
                            <th>Status</th>
                            <th>Options</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tomorrow_html}
                        </tbody>
                      </table>
                    </div>
                  </div>
              );
            }

            if(pastdue_html.length){
              pd_html.push(
                  <div data-id={index_id} data-email={contact_email} className="panel panel-default">
                    <div className="panel-body">
                      <h5>{json[k].contact?.firstName || json[k].contact?.name} {json[k].contact?.lastName || ''} | {company_name} | <button className="btn btn-primary btn-xs" onClick={() => {set_add_activity({open:true, type:'', email:contact_email, contact_id:contact_id, index_id:current_id, contact:json[k].contact}), get_ac_activites_and_scores(v2_token, rec_id, contact_id), set_history(false)}}>Create Activity</button></h5>
                      <table className="table table-bordered table-condensed">
                        <thead>
                          <tr>
                            <th>ID</th>
                            <th>Type</th>
                            <th>Summary</th>
                            <th>Email</th>
                            <th>Due Date</th>
                            <th>Status</th>
                            <th>Options</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pastdue_html}
                        </tbody>
                      </table>
                    </div>
                  </div>
              );
            }

            if(completed_html.length){
              cc_html.push(
                  <div data-id={index_id} data-email={contact_email} className="panel panel-default">
                    <div className="panel-body">
                      <h5>{json[k].contact?.firstName || json[k].contact?.name} {json[k].contact?.lastName || ''} | {company_name} | <button className="btn btn-primary btn-xs" onClick={() => {set_add_activity({open:true, type:'', email:contact_email, contact_id:contact_id, index_id:current_id, contact:json[k].contact}), get_ac_activites_and_scores(v2_token, rec_id, contact_id), set_history(false)}}>Create Activity</button></h5>
                      <table className="table table-bordered table-condensed">
                        <thead>
                          <tr>
                            <th>ID</th>
                            <th>Type</th>
                            <th>Summary</th>
                            <th>Email</th>
                            <th>Due Date</th>
                            <th>Status</th>
                            <th>Options</th>
                          </tr>
                        </thead>
                        <tbody>
                          {completed_html}
                        </tbody>
                      </table>
                    </div>
                  </div>
              );
            }

            if(no_due_html.length){
              nd_html.push(
                  <div data-id={index_id} data-email={contact_email} className="panel panel-default">
                    <div className="panel-body">
                      <h5>{json[k].contact?.firstName || json[k].contact?.name} {json[k].contact?.lastName || ''} | {company_name} | <button className="btn btn-primary btn-xs" onClick={() => {set_add_activity({open:true, type:'', email:contact_email, contact_id:contact_id, index_id:current_id, contact:json[k].contact}), get_ac_activites_and_scores(v2_token, rec_id, contact_id), set_history(false)}}>Create Activity</button></h5>
                      <table className="table table-bordered table-condensed">
                        <thead>
                          <tr>
                            <th>ID</th>
                            <th>Type</th>
                            <th>Summary</th>
                            <th>Email</th>
                            <th>Status</th>
                            <th>Options</th>
                          </tr>
                        </thead>
                        <tbody>
                          {no_due_html}
                        </tbody>
                      </table>
                    </div>
                  </div>
              );
            }
          }
           index_id++;
        });
        set_today(t_html);
        set_tomorrow(to_html);
        set_pastdue(pd_html);
        set_completed(cc_html);
        set_no_due(nd_html);
        set_main_loading(false);
      }

      async function get_campaigns(v2_token, rec_id){
        let resp = await fetch(`https://api.chartec.net/v2/ac/campaigns/${rec_id}`, {
          method: 'GET', 
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': v2_token
          }
        })
        let json = await resp.json();
        return json;
      }

      async function get_all_cw_activities(v2_token, rec_id, contact_id){
        let string = {"id": contact_id};
        let resp = await fetch(`https://api.chartec.net/v2/connectwise/sales/all_activities/${rec_id}`, {
          method: 'POST', 
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': v2_token
          },
          body: JSON.stringify(string)
        })
        let json = await resp.json();
        return json;
      }

      async function get_all_ac_activities(v2_token, rec_id, contact_id){
        let resp = await fetch(`https://api.chartec.net/v2/ac/activities_noid/${rec_id}/${contact_id}`, {
          method: 'GET', 
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': v2_token
          }
        }).then((response) => {
          if (response.status >= 400 && response.status < 600) {
            get_all_cw_activities(v2_token, rec_id, contact_id);
            return false;
          } else {
            return response;
          }
        }).catch((error) => {
          get_all_cw_activities(v2_token, rec_id, contact_id);
          return error;
        });
        let json = await resp.json();
        return json;
      }

      async function get_ac_activites_and_scores(v2_token, rec_id, contact){
        let loading_html = [];
        let small_loading = [];
        small_loading.push(<div><i className="fa fa-cog fa-spin fa-1x"></i><br/></div>);
        loading_html.push(<div className="row" style={{paddingTop : "15px"}}>
          <div className="col-xs-3 col-md-offset-4">
            <div className="panel panel-default">
              <div className="panel-body">
                <div style={{textAlign: "center"}}>
                <i className="fa fa-cog fa-spin fa-2x"></i><br/>
                Loading
                </div>
              </div>
            </div>
          </div>
        </div>);
        set_ac_lists(small_loading);
        set_ac_tags(small_loading);
        set_ac_activities(loading_html);
        set_cw_activities(loading_html);
        let campaigns = await get_campaigns(v2_token, rec_id);
        let cw_activities = await get_all_cw_activities(v2_token, rec_id, contact);
        let cw_html = [];
        Object.keys(cw_activities[contact]).forEach(function(cw){
          if(cw.match(/^[0-9]+$/) != null){
            let cw_short = cw_activities[contact][cw];
            let campaign_id = cw_short.name.split('(').pop().split(')')[0];
            let ci = campaigns.campaigns.findIndex(c => c.id == campaign_id);
            let campaign_name = campaigns.campaigns[ci]?.name || 'none';
            let title = cw_short.name.split('/')[0];
            cw_html.push(<div className="panel panel-default">
            <div className="panel-heading">{title} {cw_short.status.id == ls_settings.openStatus ? <div style={{marginTop : "-6px"}} className='pull-right btn btn-info btn-sm' data-target="#collapse_id" onClick={(e) => ($('#collapse_id').collapse('show'), $('.close-btn').show(), set_time_entry(cw_short.id))}>Time Entry</div> : ""}</div>
            <div className="panel-body">
                <small><b>Assigned To : </b></small>{cw_short.assignTo.name}<br/>
                <small><b>Type : </b></small>{cw_short.type?.name || 'none'}<br/>
                <small><b>Campaign : </b></small>{campaign_name}<br/>
                <small><b>Notes : </b></small>{cw_short.notes}<br/>
                <small><b>Status : </b></small>{cw_short.status.name}<br/>
                <small><b>Ticket ID : </b></small>{cw_short.id}<br/>
                <small title={cw_short.dateStart}>{moment(cw_short.dateStart).fromNow()}</small>
            </div>
            </div>);
          }
        });
        set_cw_activities(cw_html.reverse());

        let ac_activities = await get_all_ac_activities(v2_token, rec_id, contact);
      
        let html = [];
        Object.keys(ac_activities.activities).forEach(function(r){
          let r_short = ac_activities.activities[r];
          html.push(<div className="panel panel-default">
            <div className="panel-heading">{r_short.label}</div>
            <div className="panel-body">
              {r_short.summary} ({r_short.name})<br/>
              <small>{r_short.tstamp != null ? moment(r_short.tstamp).fromNow() : 'Unknown'}</small>
            </div>
          </div>);
        })
        let t_html = [];
        Object.keys(ac_activities.tags).forEach(function(t){
          let t_short = ac_activities.tags[t];
          t_html.push(<span style={{marginRight : "5px", padding : "3px"}} className="badge badge-secondary">{t_short.name}</span>);
        });
        let l_html = [];
        Object.keys(ac_activities.lists).forEach(function(l){
          let l_short = ac_activities.lists[l];
          l_html.push(<span style={{marginRight : "5px", padding : "3px"}} className="badge badge-secondary">{l_short.name}</span>);
        });
        let s_html = [];
        s_html.push(<span style={{marginRight : "5px", padding : "3px"}} className="badge badge-info">Contact Score : {ac_activities.score_total}</span>);
      
        set_ac_scores(s_html);
        set_ac_lists(l_html);
        set_ac_tags(t_html);
        set_ac_activities(html);
      }
    
      async function get_cw_assignment_id(v2_token, rec_id, email){
        let string = {"email": email.user.data.attributes.email};
        let resp = await fetch(`https://api.chartec.net/v2/connectwise/system/members/${rec_id}`, {
          method: 'POST', 
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': v2_token
          },
          body: JSON.stringify(string)
        })
        let json = await resp.json();
        set_assign_to_full(json[0]);
        set_user_id(json[0].id);
    }

    async function get_activities(){
        let string = {"id": user_id, "dates":dates, "settings":ls_settings};
        let resp = await fetch(`https://api.chartec.net/v2/connectwise/activities/open/${rec_id}`, {
            method: 'POST', 
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': v2_token
            },
            body: JSON.stringify(string)
        })
        let json = await resp.json();
        build_rows(json);
        let new_cards = {...cards};
        new_cards.activities = json.cycle_activities_open;
        new_cards.completed_3s = json.cycle_complete_3;
        new_cards.cycle_activities_closed = json.cycle_activities_closed;
        new_cards.open_3s = json.cycle_open_3s;
        set_cards(new_cards);
        set_card_loading(false);
    }

    async function create_activity(v2_token, rec_id, assign_to, add_activity, notes, summary, activity_id, create_status_id, time_entry_start, time_entry_end){
      let name = summary;
      let string = [
          {"name":name},
          {"contact":{"id":add_activity.contact_id}},
          {"type":{"id":activity_id }},
          {"assignTo":{"id":assign_to }},
          {"notes":notes},
          {"company":{"id": add_activity.contact.company.id}},
          {"status":{"id" : create_status_id}}, 
          {"time_entry":{"start":time_entry_start, "end":time_entry_end}},
          {"ls_settings" : ls_settings},
          {"assign_full" : assign_to_full}
        ];
      let resp = await fetch(`https://api.chartec.net/v2/connectwise/sales/create_activity/${rec_id}`, {
        method: 'POST', 
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': v2_token
        },
        body: JSON.stringify(string)
      })
      let json = await resp.json();
        if(json.id){
          setTimeout(function () {
            set_card_loading(true);
            set_main_loading(true);
            get_activities();
        }, 500);
        return true;
      } else {
        return false;
      }
    }

    async function create_time_entry(v2_token, rec_id, time_entry_info, notes, create_status_id, time_entry_start, time_entry_end){
      let string = [
        {"id" : time_entry_info.activity.id},
        {"company":{"id": time_entry_info.contact.company.id}},
        {"notes":notes},
        {"status":{"id" : create_status_id}}, 
        {"time_entry":{"start":time_entry_start, "end":time_entry_end}},
        {"ls_settings":ls_settings},
        {"assignTo":{"id":user_id}},
        {"contact":{"id":time_entry_info.contact_id}},
        {"assign_full" : assign_to_full}
      ];
      let resp = await fetch(`https://api.chartec.net/v2/connectwise/sales/create_time_entry/${rec_id}`, {
        method: 'POST', 
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': v2_token
        },
        body: JSON.stringify(string)
      })
      let json = await resp.json();
      if(json.id){
        setTimeout(function () {
          set_card_loading(true);
          set_main_loading(true);
          get_activities();
        }, 500);
        return true;
      } else {
        return false;
      }
    }

    async function change_due_date(v2_token, rec_id, schedule, new_date){
      let string = {"id" : schedule.id, "new_date":new_date};
      let resp = await fetch(`https://api.chartec.net/v2/connectwise/schedule/entries/${rec_id}`, {
        method: 'POST', 
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': v2_token
        },
        body: JSON.stringify(string)
      })
      let json = await resp.json();
      if(json.id){
        setTimeout(function () {
          set_card_loading(true);
          set_main_loading(true);
          get_activities();
        }, 500);
        return true;
      } else {
        return false;
      }
    }

    async function save(){
      let s = {open_status : open_status_id, closed_status : closed_status_id, default_work_type : work_type_id}
      const res = await jfetch.patch('/lead_safari/', {ls_settings:JSON.stringify(s)});
      if(res){
        if(res.status == "success"){
          location.reload();
        } else {
          //error
        }
      }
    }

    async function current_time(){
      var time = new Date();
      var current = time.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false });
      set_current_time_now(current);
      set_time_entry_start(current);
    }

    let v2_token = props.v2Token;
    let ls_settings = props.lsSettings;
    let rec_id = props.userContext.organization.data.attributes.connectWise.cwRecid;
    var date = new Date();
    const [user_id, set_user_id] = useState();
    const [dates, set_dates] = useState({"first_day":moment().subtract(21, "days").format("YYYY-MM-DD"), "last_day":moment().add(1,"days").format("YYYY-MM-DD")});
    const [temp_dates, set_temp_dates] = useState(dates);
    const [cards, set_cards] = useState({"activities":0, "completed_3s":0, "open_3s":0, "cycle_activities_closed":0});
    const [today, set_today] = useState([]);
    const [tomorrow, set_tomorrow] = useState([]);
    const [pastdue, set_pastdue] = useState([]);
    const [completed, set_completed] = useState([]);
    const [no_due, set_no_due] = useState([]);
    const [add_activity, set_add_activity] = useState({open:false, type:'', email:'', contact_id:'', index_id:0, contact:{}});
    const [notes, set_notes] = useState("");
    const [activity_types, set_activity_types] = useState([]);
    const [activity_statuses, set_activity_statuses] = useState([]);
    const [activity_id, set_activity_id] = useState('');
    const [summary, set_summary] = useState("");
    const [ac_activities, set_ac_activities] = useState([]);
    const [cw_activities, set_cw_activities] = useState([]);
    const [ac_tags, set_ac_tags] = useState([]);
    const [ac_scores, set_ac_scores] = useState([]);
    const [ac_lists, set_ac_lists] = useState([]);
    const [history, set_history] = useState(false);
    const [progress, set_progress] = useState([true]);
    const [card_loading, set_card_loading] = useState(true);
    const [main_loading, set_main_loading] = useState(true);
    const [settings_open, set_settings_open] = useState(false);
    const [open_status_id, set_open_status_id] = useState(ls_settings.openStatus);
    const [closed_status_id, set_closed_status_id] = useState(ls_settings.closedStatus);
    const [work_type_id, set_work_type_id] = useState(ls_settings.defaultWorkType);
    const [work_types, set_work_types] = useState([]);
    const [create_status_id, set_create_status_id] = useState();
    const [not_ready, set_not_ready] = useState(false);
    const [time_entry_start, set_time_entry_start] = useState<any>();
    const [time_entry_end, set_time_entry_end] = useState();
    const [time_entry, set_time_entry] = useState(0);
    const [assign_to_full, set_assign_to_full] = useState([]);
    const [add_time_modal, set_add_time_modal] = useState<any>({open:false, email:'', contact_id:'', index_id:0, contact:{}, activity:{}});
    const [due_date_modal, set_due_date_modal] = useState<any>({open:false, new: '', activity:{}});
    const [current_time_now, set_current_time_now] = useState('');
    let small_loading = <div><i className="fa fa-cog fa-spin fa-1x"></i><br/></div>;
    let large_loading = <div className="row" style={{paddingTop : "15px"}}>
    <div className="col-xs-8 col-md-offset-4">
      <div className="panel panel-default">
        <div className="panel-body">
          <div style={{textAlign: "center"}}>
          <i className="fa fa-cog fa-spin fa-2x"></i><br/>
          Loading
          </div>
        </div>
      </div>
    </div>
  </div>;

    useEffect(() => {
        get_cw_assignment_id(v2_token, rec_id, props.userContext);
    }, [])

    useEffect(() => {
        if(user_id){
          if(ls_settings.openStatus != '' && ls_settings.closedStatus != '' && ls_settings.defaultWorkType != ''){
            get_activities();
            get_activity_types_html(v2_token, rec_id);
            get_activity_statuses(v2_token, rec_id);
            get_work_types(v2_token, rec_id);
          } else {
            set_not_ready(true);
            get_activity_types_html(v2_token, rec_id);
            get_activity_statuses(v2_token, rec_id);
            get_work_types(v2_token, rec_id);
          }
        }
    }, [user_id])


  return(
    <div className="col-md-12" style={{marginTop : '20px'}}>
      {not_ready ? 
        <div className="row" style={{paddingTop : "15px"}}>
          <div className="col-xs-3 col-md-offset-4">
            <div className="panel panel-default">
              <div className="panel-body">
                <div style={{textAlign: "center"}}>
                  Please select Acitvity Statuses and Default Work Type by clicking on settings button
                </div>
              </div>
            </div>
          </div>
        </div> 
        : 
        <span>
        <div className="col-xs-6 col-sm-3">
            <div className="hpanel stats">
                <div className="panel-body h-100">
                    <div className="stats-title pull-left"><h4>Total Open Activities</h4></div>
                    <div className="stats-icon pull-right"><i className="pe-7s-monitor fa-4x"></i></div>
                    <div className="m-t-xl">
                        <h1 className="text-info">{card_loading ? small_loading :cards.activities||0}</h1>
                    </div>
                    <small>Amount of open activitie.</small>
                </div>
            </div>
        </div>
        
        <div className="col-xs-6 col-sm-3">
            <div className="hpanel stats">
                <div className="panel-body h-100">
                    <div className="stats-title pull-left"><h4>Completed Activities</h4></div>
                    <div className="stats-icon pull-right"><i className="pe-7s-monitor fa-4x"></i></div>
                    <div className="m-t-xl">
                        <h1 className="text-success">{card_loading ? small_loading :cards.cycle_activities_closed}</h1>
                    </div>
                    <small>Amount of completed activities this cycle.</small>
                </div>
            </div>
        </div>
        
        <div className="col-xs-6 col-sm-3">
            <div className="hpanel stats">
                <div className="panel-body h-100">
                    <div className="stats-title pull-left"><h4>Total Past Due Activites</h4></div>
                    <div className="stats-icon pull-right"><i className="pe-7s-monitor fa-4x"></i></div>
                    <div className="m-t-xl">
                        <h1 className="text-danger">{card_loading ? small_loading :(pastdue.length)}</h1>
                    </div>
                    <small>Amount of past due activities.</small>
                </div>
            </div>
        </div>
        
        <div className="col-xs-6 col-sm-3">
            <div className="hpanel stats">
                <div className="panel-body h-100">
                    <div className="stats-title pull-left"><h4>Total Activities Due Today</h4></div>
                    <div className="stats-icon pull-right"><i className="pe-7s-monitor fa-4x"></i></div>
                    <div className="m-t-xl">
                        <h1 className="text-warning">{card_loading ? small_loading :today.length}</h1>
                    </div>
                    <small>Amount of activities due today.</small>
                </div>
            </div>
        </div>
        </span>
        }
        <a href="/lead_safari" style={{marginBottom : '10px'}} className="btn btn-primary">View Lead Safari</a>
        <button style={{marginTop: "-10px", marginLeft: '5px'}} onClick={(e) => set_settings_open(true)} className="btn btn-info"><i className="fa fa-cog"></i></button>
        {not_ready ? "" :
        <span>
          <ul className="nav nav-tabs" role="tablist">
              <li role="presentation" className="active"><a href="#today" aria-controls="today" role="tab" data-toggle="tab">Today <span className="badge badge-warning"> {main_loading ? small_loading :today.length}</span></a></li>
              <li role="presentation"><a href="#tomorrow" aria-controls="tomorrow" role="tab" data-toggle="tab">Tomorrow  <span className="badge badge-info"> {main_loading ? small_loading :tomorrow.length}</span></a></li>
              <li role="presentation"><a href="#pastdue" aria-controls="pastdue" role="tab" data-toggle="tab">Past Due  <span className="badge badge-danger"> {main_loading ? small_loading :pastdue.length}</span></a></li>
              <li role="presentation"><a href="#completed" aria-controls="complete" role="tab" data-toggle="tab">Complete  <span className="badge badge-success"> {main_loading ? small_loading :cards.cycle_activities_closed}</span></a></li>
              <li role="presentation"><a href="#no_due" aria-controls="no_due" role="tab" data-toggle="tab">No Due Date  <span className="badge badge-success"> {main_loading ? small_loading :no_due.length}</span></a></li>
          </ul>
          <br/>
          <div className="tab-content">
              <div role="tabpanel" className="tab-pane active" id="today">
                {main_loading ? large_loading :
                    today.length ? today : <div className="panel panel-default"><div className="panel-body">No Activities Due Today</div></div>
                }
              </div>
              <div role="tabpanel" className="tab-pane" id="tomorrow">
                {main_loading ? large_loading :
                    tomorrow.length ? tomorrow : <div className="panel panel-default"><div className="panel-body">No Activities Due Tomorrow</div></div>
                }
              </div>
              <div role="tabpanel" className="tab-pane" id="pastdue">
                {main_loading ? large_loading :
                    pastdue.length ? pastdue : <div className="panel panel-default"><div className="panel-body">No Activities Past Due</div></div>
                }
              </div>
              <div role="tabpanel" className="tab-pane" id="completed">
                {main_loading ? large_loading :
                    completed.length ? completed : <div className="panel panel-default"><div className="panel-body">No Activities Completed</div></div>
                }
              </div>
              <div role="tabpanel" className="tab-pane" id="no_due">
                {main_loading ? large_loading :
                    no_due.length ? no_due : <div className="panel panel-default"><div className="panel-body">No Activities Here</div></div>
                }
              </div>
          </div>
        </span>
        }


        <Modal
              title="Activity"
              open={add_activity.open}
              isLarge={true}
              submittable={false}
              closeText="Cancel"
              disallowClickOutside={true}
              close={() => {set_notes(''), set_add_activity({open:false, type:'' , email:'', contact_id:'', index_id: 0, contact:{}})}}
            >
              {history ? '' :
                <span>
                    <div className="row">
                      {time_entry ? "" :
                        <div className="col-sm-6">
                          <div className="fix-height form-group">
                            <label className="control-label">Activity Types</label>
                            <Select value={activity_types.find(obj => obj.value === activity_id)} options={activity_types} onChange={(e) => handle_select(e)} />
                          </div>
                        </div>
                      }
                      <div className="col-sm-6">
                        <div className="fix-height form-group">
                          <label className="control-label">Activity Status</label>
                          <Select value={activity_statuses.find(obj => obj.value === create_status_id)} options={activity_statuses} onChange={(e:any) => set_create_status_id(e.value)} />
                        </div>
                      </div>
                    </div>
                    {time_entry ? "" :
                      <div className="checkbox">
                          <label style={{fontWeight : "bold"}} data-toggle="collapse" data-target="#collapseTime">
                              <input style={{width: "auto",marginTop: "-11px"}} type="checkbox"/> Add Time Entry 
                          </label>
                      </div>
                    }
                    <span className={`${time_entry ? "" : 'collapse'}`} id="collapseTime">
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label className="control-label">Start <small>(Time Entry)</small></label>
                            <input type="time" defaultValue={current_time_now} id="start" name="start" onChange={(e:any) => (set_time_entry_start(e.target.value))}/>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label className="control-label">End <small>(Time Entry)</small></label>
                            <input type="time" defaultValue={current_time_now} id="end" name="end" onChange={(e:any) => set_time_entry_end(e.target.value)}/>
                          </div>
                        </div>
                      </div>
                    </span>
                    <div className="row">
                      <div className="col-sm-12">
                        {time_entry ? "" :
                          <div className="form-group">
                            <label>Summary:</label>
                            <input onChange={(e) => set_summary(e.target.value)} value={summary} type="text" className="form-control" id="summary"/>
                          </div>
                        }
                        <div className="form-group">
                          <label>Note:</label>
                          <input onChange={(e) => set_notes(e.target.value)} value={notes} type="text" className="form-control" id="note"/>
                        </div>
                        {!time_entry ? <button className="btn btn-primary" onClick={() => create_activity(v2_token, rec_id, user_id, add_activity, notes, summary, activity_id, create_status_id, time_entry_start, time_entry_end).then(value => {set_add_activity({open:false, type:'', email:'', contact_id:'', index_id:0, contact:{}}), toast.success('Activity Created'), set_notes('')}, reason => {toast.error('Activity Not Created')})}>Create Activity</button>
                         : <button className="btn btn-primary" onClick={() => create_time_entry(v2_token, rec_id, add_activity, notes, create_status_id, time_entry_start, time_entry_end).then(value => {set_add_activity({open:false, type:'', email:'', contact_id:'', index_id:0, contact:{}}), toast.success('Entry Created'), set_notes('')}, reason => {toast.error('Entry Not Created')})}>Create Time Entry</button>
                        }
                      </div>
                    </div>
                    <hr />
                  </span>
              }
              <div>
              <ul className="nav nav-tabs" role="tablist">
                <li role="presentation" className="active"><a href="#connectwise" aria-controls="connectwise" role="tab" data-toggle="tab">ConnectWise</a></li>
                <li role="presentation"><a href="#ac" aria-controls="ac" role="tab" data-toggle="tab">Active Campaign</a></li>
              </ul>
              <br/>
              <div className="tab-content">
                <div role="tabpanel" className="tab-pane active" id="connectwise">{cw_activities}</div>
                <div role="tabpanel" className="tab-pane" id="ac">
                  <h5>AC Lists</h5>
                  <div>{ac_lists}</div>
                  <hr/>
                  <h5>AC Tags</h5>
                  <div>{ac_tags}</div>
                  <hr/>
                  {ac_scores}<br/><br/>
                  {ac_activities}
                </div>
              </div>
              </div>
            </Modal>


            <Modal
              title="Time Entry"
              open={add_time_modal.open}
              isLarge={true}
              submittable={false}
              closeText="Cancel"
              disallowClickOutside={true}
              close={() => {set_time_entry_start(null), set_time_entry_end(null), set_add_time_modal({open:false, type:'' , email:'', contact_id:'', index_id: 0, contact:{}, activity:{}})}}
            >
                  <span>
                    <table className="table table-bordered table-condensed">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Type</th>
                          <th>Summary</th>
                          <th>Email</th>
                          <th>Due Date</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td>{add_time_modal.activity.id || ''}</td>
                        <td>{add_time_modal.activity.type?.name || ''}</td>
                        <td>{add_time_modal.activity.name || ''}</td>
                        <td>{add_time_modal.activity.email || ''}</td>
                        <td>{moment(add_time_modal.activity.schedule?.dateEnd).format("MMMM Do, YYYY") || ''}</td>
                        <td>{add_time_modal.activity.status?.name || ''}</td>
                      </tr>
                      </tbody>
                    </table>
                    <br/>
                    <div className="row">
                      
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label className="control-label">Activity Types</label>
                          <Select value={activity_types.find(obj => obj.value === activity_id)} options={activity_types} onChange={(e) => handle_select(e)} />
                        </div>
                      </div>
                    
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label className="control-label">Activity Status</label>
                          <Select value={activity_statuses.find(obj => obj.value === create_status_id)} options={activity_statuses} onChange={(e:any) => set_create_status_id(e.value)} />
                        </div>
                      </div>
                    </div>
  
                    <span>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label className="control-label">Start <small>(Time Entry)</small></label>
                            <input type="time" defaultValue={current_time_now} id="start" name="start" onChange={(e:any) => (set_time_entry_start(e.target.value))}/>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label className="control-label">End <small>(Time Entry)</small></label>
                            <input type="time" id="end" name="end" onChange={(e:any) => set_time_entry_end(e.target.value)}/>
                          </div>
                        </div>
                      </div>
                    </span>

                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label>Note:</label>
                          <textarea onChange={(e) => set_notes(e.target.value)} value={notes} className="form-control" id="note"/>
                        </div>
                        <button className="btn btn-primary" onClick={() => create_time_entry(v2_token, rec_id, add_time_modal, notes, create_status_id, time_entry_start, time_entry_end).then(value => {set_add_time_modal({open:false, type:'' , email:'', contact_id:'', index_id: 0, contact:{}, activity:{}}), toast.success('Entry Created'), set_notes('')}, reason => {toast.error('Entry Not Created')})}>Create Time Entry</button>
                      </div>
                    </div>

                  </span>
            </Modal>


            <Modal
              title="Change Due Date"
              open={due_date_modal.open}
              submittable={false}
              isLarge={true}
              closeText="Close"
              disallowClickOutside={false}
              close={() => {set_due_date_modal({open:false, activity:{}})}}>
                <table className="table table-bordered table-condensed">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Type</th>
                      <th>Summary</th>
                      <th>Email</th>
                      <th>Due Date</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>{due_date_modal.activity.id || ''}</td>
                    <td>{due_date_modal.activity.type?.name || ''}</td>
                    <td>{due_date_modal.activity.name || ''}</td>
                    <td>{due_date_modal.activity.email || ''}</td>
                    <td>{moment(due_date_modal.activity.schedule?.dateEnd).format("MMMM Do, YYYY") || ''}</td>
                    <td>{due_date_modal.activity.status?.name || ''}</td>
                  </tr>
                  </tbody>
                </table>
                <br/>
                <label style={{marginLeft : '15px'}}>Change Due Date:</label>
                <input onChange={(e) => {due_date_modal.new = e.target.value}} type="date" id="due" name="due" style={{display: "inline", marginLeft: "5px"}}/>
                <button onClick={() => {change_due_date(v2_token, rec_id, due_date_modal.activity.schedule, due_date_modal.new).then(value => {set_due_date_modal({open:false, activity:{}}), toast.success('Due Date Changed')}, reason => {toast.error('Due Date Not Updated')})}} className="btn btn-primary">Apply</button>
            </Modal>


            <Modal
              title="Settings"
              open={settings_open}
              submittable={false}
              closeText="Done"
              disallowClickOutside={false}
              close={() => {set_settings_open(false)}}>
                <h6 style={{marginLeft : '15px'}}>Select time period to get contact touch counts ( Default is past 21 days)</h6>
                <br/>
                <label style={{marginLeft : '15px'}}>Start date:</label>
                <input onChange={(e) => {temp_dates.first_day = e.target.value, set_temp_dates({...temp_dates})}} type="date" id="start" name="start" style={{display: "inline", marginLeft: "5px"}}
                  value={temp_dates.first_day}/>
                <label style={{marginLeft : '15px'}}>End date:</label>
                <input onChange={(e) => {temp_dates.last_day = e.target.value, set_temp_dates({...temp_dates})}} type="date" id="start" name="end" style={{display: "inline", marginLeft: "5px"}}
                  value={temp_dates.last_day}/>
                <label style={{marginLeft : '15px'}}>Open Status:</label>
                <Select isMulti className="basic-multi-select" value={open_status_id} options={activity_statuses} onChange={(e:any) => set_open_status_id(e)} />
                <label style={{marginLeft : '15px'}}>Closed Status:</label>
                <Select isMulti className="basic-multi-select" value={closed_status_id} options={activity_statuses} onChange={(e:any) => {set_closed_status_id(e)}} />
                <label style={{marginLeft : '15px'}}>Default Work Type:</label>
                <Select value={work_types.find(obj => obj.value === work_type_id)} options={work_types} onChange={(e:any) => set_work_type_id(e.value)} />
                <br/>
                <button onClick={() => {save(), set_card_loading(true),set_main_loading(true),get_activities(), set_dates(temp_dates), set_settings_open(false)}} className="btn btn-primary">Apply</button>
            </Modal>
    </div>
  )
}

export default LeadSafariProgress


// WEBPACK FOOTER //
// ./app/javascript/components/pages/LeadSafariProgress.tsx